import {
    defineStore,
} from 'pinia'
import {
    useContextStore,
} from '~~/stores/context'
import { PROVIDERS } from '#shared/providers'

export const useTallyfyStore = defineStore('tallyfy', () => {
    const PROVIDER = PROVIDERS.TALLYFY

    const blueprints = ref([])

    const contextStore = useContextStore()
    contextStore.registerProvider(PROVIDER)

    const ctx = computed(() => contextStore.getContext(PROVIDER))
    watch(ctx, (newCtx, oldCtx) => {
        if (newCtx?.identityKey !== oldCtx?.identityKey) {
            blueprints.value = []
        }
    })

    async function fetchBlueprints() {
        useRequest({
            label: 'fetch tallyfy blueprints',
            fetch: () => $fetch('/api/tallyfy/blueprints', {
                method: 'GET',
            }),
            evaluate: ({ blueprints: b }) => [...b],
            store: (b) => blueprints.value = b,
            successDetails: (b) => [b.length],
        })
    }

    // The drawer log brackets the whole execution (begin/end/error) via the
    // single request label; per-process progress rides the SSE bus to the page.
    async function generateProcesses({ name, key }: { name: string; key: string }) {
        await useRequest({
            label: `generate ${name} processes`,
            fetch: () => $fetch('/api/automation/processes', {
                method: 'POST',
                body: { name, key },
            }),
        })
    }

    function init() {}

    return {
        blueprints,
        fetchBlueprints,
        generateProcesses,
        init,
    }
})
